<template>
  <div v-if="show" class="model">
    <div class="model-bg">
      <div v-if="winPrice > 0" class="model-box">
        <div class="model-box-title">恭喜！获得红包现金</div>
        <div class="model-box-money">
          <span>{{ winPrice }}</span>
          元
        </div>
        <div class="question-succ">本次共答对 {{ rightCount }} 题</div>
        <div class="btn-img">
          <img src="@/assets/prize/model/sx.png" alt="" @click="submit(1)" />
        </div>
      </div>
      <div v-else class="model-box">
        <div class="no-img-box">
          <img src="@/assets/prize/model/no-img.png" alt="" />
        </div>
        <div class="model-box-title">很遗憾！未中奖</div>
        <div class="question-succ">本次共答对 {{ rightCount }} 题</div>
        <div class="btn-img">
          <img src="@/assets/prize/model/btn.png" alt="" @click="submit()" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { redPacket } from "@/api/active/active";
import { authSign } from "@/api/active/active";
import { Dialog } from "vant";
export default {
  name: "Model",
  props: {
    winPrice: {
      type: [Number, String],
      default: 0,
    },
    isCheckWinAnswer: {
      type: [Number, String],
      default: 0,
    },
  },
  data() {
    return {
      show: false,
      rightCount: 0,
    };
  },
  created() {},
  methods: {
    redPacketFn() {
      this.wxOpenid = localStorage.getItem("wxOpenid");
      let data = {
        openId: this.wxOpenid,
      };
      redPacket(data)
        .then(() => {})
        .catch(() => {});
    },
    submit(type) {
      document.body.style.overflow = "";
      this.show = false;
      if (type == 1) {
        // this.redPacketFn();
        this.getMoney();
      }
      localStorage.setItem("isCheckWinAnswer", 1);
    },
    async getMoney() {
      try {
        let data = {
          // timestamp: new Date().getTime(),
          url: window.location.href.split("#")[0],
        };
        const res = await authSign(data);
        // eslint-disable-next-line no-undef
        wx.config({
          // debug: true,
          appId: "wx7cbd7ff9855f3660",
          timestamp: res.data.timestamp,
          signature: res.data.sign,
          nonceStr: res.data.nonceStr,
          jsApiList: ["requestMerchantTransfer"], // 声明需要调用的接口
        });
        // eslint-disable-next-line no-undef
        wx.error((res) => {
          Dialog({ message: "微信SDK初始化失败!" + JSON.stringify(res) });
        });
        // eslint-disable-next-line no-undef
        wx.ready(function () {
          // eslint-disable-next-line no-undef
          wx.checkJsApi({
            jsApiList: ["requestMerchantTransfer"],
            success: function (res) {
              if (res.checkResult["requestMerchantTransfer"]) {
                let packageInfo = localStorage.getItem("packageInfo");
                // eslint-disable-next-line no-undef
                WeixinJSBridge.invoke(
                  "requestMerchantTransfer",
                  {
                    mchId: "1610070512",
                    appId: "wx7cbd7ff9855f3660",
                    package: packageInfo,
                  },
                  function (res) {
                    if (res.err_msg === "requestMerchantTransfer:ok") {
                      // res.err_msg将在页面展示成功后返回应用时返回success，并不代表付款成功
                    }
                  }
                );
              } else {
                alert("你的微信版本过低，请更新至最新版本。");
              }
            },
          });
        });

        //   wx.ready(function () {
        //     // Dialog({ message: "成功" });
        //     // eslint-disable-next-line no-undef
        //     console.log(wx);

        // //     let packageInfo = localStorage.getItem("packageInfo");
        // //     // eslint-disable-next-line no-undef
        // //  wx.checkJsApi({
        // //       jsApiList: ['requestMerchantTransfer'], {
        // //       mchId: "1610070512",
        // //       appId: "wx7cbd7ff9855f3660",
        // //       package: packageInfo,
        // //       success: (res) => {
        // //         // res.err_msg将在页面展示成功后返回应用时返回ok，并不代表付款成功
        // //         // console.log("success:", res);
        // //         alert(JSON.stringify(res));
        // //       },
        // //       fail: (res) => {
        // //         alert(JSON.stringify(res));
        // //         // console.log("fail:", res);
        // //       },
        // //     });
        //   });
      } catch {
        //
      }
    },
    init() {
      this.show = true;
      this.rightCount = localStorage.getItem("rightCount");
      // 禁止滚动
      document.body.style.overflow = "hidden";
    },
  },
};
</script>
<style lang="scss" scoped>
.model {
  width: 100vw;
  height: 100vh;
  z-index: 9999;
  background: rgba(37, 38, 45, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  left: 0;
  top: 0;
  // display: none;
  .btn-img {
    position: absolute;
    top: 23em;
    display: flex;
    width: 100%;
    justify-content: center;
    img {
      width: 16em;
    }
  }
  .question-succ {
    color: #844c3a;
  }
  .model-box-money {
    color: #844c3a;
    span {
      font-size: 2.2em;
      color: #f10507;
    }
  }
  .model-box {
    padding-top: 132px;
    z-index: 1;
    text-align: center;
    position: relative;
    .no-img-box {
      margin-top: -1em;
      display: flex;
      width: 100%;
      justify-content: center;
      img {
        width: 8em;
      }
    }
    .model-box-title {
      color: #ff3f16;
      font-size: 2em;
    }
  }
  .model-bg {
    width: 23em;
    height: 520px;
    background: url("~@/assets/prize/model/bg.png") no-repeat;
    background-size: 100%;
  }
}
</style>
